import {AbstractSecurityStorage} from "angular-auth-oidc-client";

// Required as the OIDC client version that supports Angular 14 doesn't have this class available by default.
export class AuthSessionStorageService implements AbstractSecurityStorage {
    clear(): void {
      sessionStorage.clear();
    }

    read(key: string): any {
        return sessionStorage.getItem(key);
    }

    remove(key: string): void {
        return sessionStorage.removeItem(key)
    }

    write(key: string, value: any): void {
        return sessionStorage.setItem(key, value);
    }

}
